export type Info360Kind = 'cliente' | 'producto';

const PREFIX = 'info360.ultimaSolapa';

function storageKey(kind: Info360Kind, username: string, tenantId: number | null): string {
  return `${PREFIX}.${kind}:${tenantId ?? 0}:${username.trim().toLowerCase()}`;
}

export function loadInfo360Tab<T extends string>(
  kind: Info360Kind,
  username: string | null | undefined,
  tenantId: number | null,
  allowed: readonly T[],
  fallback: T,
): T {
  if (typeof window === 'undefined' || !username?.trim()) return fallback;
  try {
    const raw = localStorage.getItem(storageKey(kind, username, tenantId));
    if (!raw) return fallback;
    return allowed.includes(raw as T) ? (raw as T) : fallback;
  } catch {
    return fallback;
  }
}

export function saveInfo360Tab(
  kind: Info360Kind,
  username: string | null | undefined,
  tenantId: number | null,
  tab: string,
): void {
  if (typeof window === 'undefined' || !username?.trim()) return;
  try {
    localStorage.setItem(storageKey(kind, username, tenantId), tab);
  } catch {
    /* quota */
  }
}
